
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[communityId]",
      function () {
        return require("private-next-pages/[communityId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[communityId]"])
      });
    }
  